import ErrorPage from "components/404"
import { size, get } from "lodash"
import createModule from "../createModule"
import view from "./view"
import { getWatchlist, getWatchlistId, getModelId, getModel, getModelStartDate, getModelCurrentDate, getSelectedDate, getCurrency, getUnsupportedCurrencyWarning, getAllModelIds } from "./selectors"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as ResourceCreators } from "modules/resources/model"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { Creators } from "./model"
import { getUnmodeledDates } from "selectors/dates"
import { getContextualMenuItems } from "./selectors/menu"
import withUrlParams from "hocs/withUrlParams"
import { MODELS_QUERY, MODEL_METADATA_QUERY, getModels } from "resources/models"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    accountId: state.global.selected.accountId,
    account: state.global.selected.account,
    watchlistId: getWatchlistId(props),
    modelId: getModelId(state),
    modelStartDate: getModelStartDate(state),
    modelEndDate: getModelCurrentDate(state),
    models: getModels(state),
  }),
  required: ["account", "accountId", "watchlistId"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "watchlist",
    as: null,
    url: ({ watchlistId }) => ({
      id: watchlistId,
      query: "query($id: String!) { watchlist(id: $id) { id, name, description, count, alias, lastUpdated } }",
      variables: {
        id: watchlistId,
      },
    }),
  }, {
    ...MODELS_QUERY,
    as: null,
  }, {
    resource: "dates",
    as: null,
    url: ({ modelId }) => {
      if (!modelId) {
        return null
      }

      return {
        id: modelId,
        query: `query ($modelId: String!) {
          model (id: $modelId) {
            availability {
              currentDate,
              factorsStartDate,
              securitiesStartDate
            }
          }
        }`,
        variables: { modelId },
      }
    },
  }, {
    resource: "modeledDates",
    as: null,
    url: ({ modelId, modelEndDate, modelStartDate }) => {
      if (!modelId || !modelEndDate || !modelStartDate) {
        return null
      }

      return {
        id: `${modelId}${modelEndDate}${modelStartDate}`,
        query: "query ($modelId: String!, $from: Date!, $to: Date!) { model (id: $modelId) { availability { dates(from: $from, to: $to) } } }",
        variables: { modelId, from: modelStartDate, to: modelEndDate },
      }
    },
  }, {
    resource: "watchlistRootPreferences",
    url: ({ accountId, models }) => {
      if (size(models) === 0) {
        return null
      }

      return ({
        id: `watchlistRootPreferences-${accountId}`,
        url: "/api/users/me/preferences",
        payload: {
          items: [
            {
              type: "watchlistLastModelUsed",
              accountId,
            },
          ],
        },
      })
    },
  }, {
    resource: "userFavoriteResources",
    url: ({ accountId }) => ({
      id: `userFavoriteResources-${accountId}`,
      url: "/api/users/me/preferences",
      payload: {
        items: [{ type: "favoriteResources", accountId }],
      },
    }),
  }, {
    resource: "resourcePermission",
    url: ({ watchlistId }) => {
      return {
        id: `resource-permission-${watchlistId}`,
        query: `query ($resourceType: ResourceType!, $resourceId: IdOrShortIdOrAlias!) {
          resource(type: $resourceType, id: $resourceId) {
            id
            permissionLevel
          }
        }`,
        variables: {
          resourceType: "WATCHLIST",
          resourceId: watchlistId,
        },
      }
    },
  }, MODEL_METADATA_QUERY],
  mapStateToProps: (state, props) => ({
    watchlist: getWatchlist(state, props),
    security: state.modules.portfolioRoot.security,
    factorId: state.modules.portfolioRoot.factorId,
    unmodeledDates: getUnmodeledDates(state),
    selectedDate: getSelectedDate(state),
    sessionExpired: get(state, "user.sessionExpired"),
    menuItems: getContextualMenuItems(state, props),
    currency: getCurrency(state, props),
    modelIds: getAllModelIds(state, props),
    selectedModel: getModel(state, props),
    unsupportedCurrencyWarning: getUnsupportedCurrencyWarning(state, props),
  }),
  error: ErrorPage,
  actions: {
    ...Creators,
    closeSecurityProfile: ProfileCreators.closeSecurityProfile,
    closeFactorProfile: ProfileCreators.closeFactorProfile,
    addNotification: NotificationCreators.add,
    updateWatchlist: ResourceCreators.updateWatchlist,
    deleteWatchlist: ResourceCreators.deleteWatchlist,
    toggleFavorite: ResourceCreators.toggleFavorite,
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
  },
}))
